<template>
  <v-navigation-drawer v-model="drawer" fixed app>
    <v-toolbar color="primary darken-1" dark>
      <v-toolbar-title class="ml-0 pl-3">
        <span>Menu</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-list dense>
      <v-list-tile to="/home">
        <v-list-tile-action>
          <v-icon>home</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- <v-list-tile to="/about">
        <v-list-tile-action>
          <v-icon>contact_mail</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Contact</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>-->

      <v-list-tile to="/manageUser">
        <v-list-tile-action>
          <v-icon>face</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Users</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- <v-list-tile to="/manageUserTypes">
        <v-list-tile-action>
          <v-icon>contact_mail</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Users Types</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>-->

      <!-- <v-list-tile to="/formViewer">
        <v-list-tile-action>
          <v-icon>contact_mail</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Form</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>-->

      <!-- <v-list-tile to="/dataFormViewer">
        <v-list-tile-action>
          <v-icon>contact_mail</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>DataForm</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>-->

      <v-list-tile to="/formsManager">
        <v-list-tile-action>
          <v-icon>assignment</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Form Manager</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- <v-list-tile @click="logout()">
        <v-list-tile-action>
          <v-icon>power_settings_new</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>logout</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile> -->


    </v-list>
  </v-navigation-drawer>
</template>

<script>
import config from "../config.js";
const serverHost = config.backendServerHost;

export default {
  name: "sidebar",
  // props: ["drawer"],
  created() {
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.drawer = !this.drawer;
    });
  },
  data: () => ({
    drawer: false
  }),
  methods: {
    logout() {
      console.log("loggin out of the system");


     this.$axios
        .get(
          serverHost + "/logout"
        )
        .then(response => {
          //console.log(response);

          if (response.status == 401) {
         //  window.location = '/';
              
          }
        })
        .catch(error => {
          console.log(error);
          this.loading=false;
        });

    }
  }
};
</script>


